export class Order {
}
export var CreditCardType;
(function (CreditCardType) {
    CreditCardType[CreditCardType["NA"] = 0] = "NA";
    CreditCardType[CreditCardType["Alelo"] = 1] = "Alelo";
    CreditCardType[CreditCardType["Alia"] = 2] = "Alia";
    CreditCardType[CreditCardType["AmericanExpress"] = 3] = "AmericanExpress";
    CreditCardType[CreditCardType["Cabal"] = 4] = "Cabal";
    CreditCardType[CreditCardType["Carnet"] = 5] = "Carnet";
    CreditCardType[CreditCardType["Dankort"] = 6] = "Dankort";
    CreditCardType[CreditCardType["DinersClub"] = 7] = "DinersClub";
    CreditCardType[CreditCardType["Discover"] = 8] = "Discover";
    CreditCardType[CreditCardType["Elo"] = 9] = "Elo";
    CreditCardType[CreditCardType["ForbrugsForeningen"] = 10] = "ForbrugsForeningen";
    CreditCardType[CreditCardType["Jcb"] = 11] = "Jcb";
    CreditCardType[CreditCardType["Maestro"] = 12] = "Maestro";
    CreditCardType[CreditCardType["Master"] = 13] = "Master";
    CreditCardType[CreditCardType["Naranja"] = 14] = "Naranja";
    CreditCardType[CreditCardType["Sodexo"] = 15] = "Sodexo";
    CreditCardType[CreditCardType["Unionpay"] = 16] = "Unionpay";
    CreditCardType[CreditCardType["Visa"] = 17] = "Visa";
    CreditCardType[CreditCardType["Vr"] = 18] = "Vr";
})(CreditCardType || (CreditCardType = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod[PaymentMethod["CreditCard"] = 0] = "CreditCard";
    PaymentMethod[PaymentMethod["ElectronicWallet"] = 1] = "ElectronicWallet";
    PaymentMethod[PaymentMethod["GiftCertificate"] = 2] = "GiftCertificate";
    PaymentMethod[PaymentMethod["StoreCredit"] = 3] = "StoreCredit";
    PaymentMethod[PaymentMethod["ApplePayCard"] = 4] = "ApplePayCard";
    PaymentMethod[PaymentMethod["BigpayCard"] = 5] = "BigpayCard";
    PaymentMethod[PaymentMethod["ApplePayToken"] = 6] = "ApplePayToken";
    PaymentMethod[PaymentMethod["Token"] = 7] = "Token";
    PaymentMethod[PaymentMethod["Custom"] = 8] = "Custom";
    PaymentMethod[PaymentMethod["OffSite"] = 9] = "OffSite";
    PaymentMethod[PaymentMethod["OffLine"] = 10] = "OffLine";
    PaymentMethod[PaymentMethod["Nonce"] = 11] = "Nonce";
})(PaymentMethod || (PaymentMethod = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus[PaymentStatus["Unknown"] = 0] = "Unknown";
    PaymentStatus[PaymentStatus["Authorized"] = 1] = "Authorized";
    PaymentStatus[PaymentStatus["Captured"] = 2] = "Captured";
    PaymentStatus[PaymentStatus["CapturePending"] = 3] = "CapturePending";
    PaymentStatus[PaymentStatus["Declined"] = 4] = "Declined";
    PaymentStatus[PaymentStatus["HeldForReview"] = 5] = "HeldForReview";
    PaymentStatus[PaymentStatus["Paid"] = 6] = "Paid";
    PaymentStatus[PaymentStatus["PartiallyRefunded"] = 7] = "PartiallyRefunded";
    PaymentStatus[PaymentStatus["Pending"] = 8] = "Pending";
    PaymentStatus[PaymentStatus["Refunded"] = 9] = "Refunded";
    PaymentStatus[PaymentStatus["Void"] = 10] = "Void";
    PaymentStatus[PaymentStatus["VoidPending"] = 11] = "VoidPending";
})(PaymentStatus || (PaymentStatus = {}));
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus[OrderStatus["Incomplete"] = 0] = "Incomplete";
    OrderStatus[OrderStatus["Pending"] = 1] = "Pending";
    OrderStatus[OrderStatus["Shipped"] = 2] = "Shipped";
    OrderStatus[OrderStatus["PartiallyShipped"] = 3] = "PartiallyShipped";
    OrderStatus[OrderStatus["Refunded"] = 4] = "Refunded";
    OrderStatus[OrderStatus["Cancelled"] = 5] = "Cancelled";
    OrderStatus[OrderStatus["Declined"] = 6] = "Declined";
    OrderStatus[OrderStatus["AwaitingPayment"] = 7] = "AwaitingPayment";
    OrderStatus[OrderStatus["AwaitingPickup"] = 8] = "AwaitingPickup";
    OrderStatus[OrderStatus["AwaitingShipment"] = 9] = "AwaitingShipment";
    OrderStatus[OrderStatus["Completed"] = 10] = "Completed";
    OrderStatus[OrderStatus["AwaitingFulfillment"] = 11] = "AwaitingFulfillment";
    OrderStatus[OrderStatus["ManualVerificationRequired"] = 12] = "ManualVerificationRequired";
    OrderStatus[OrderStatus["Disputed"] = 13] = "Disputed";
    OrderStatus[OrderStatus["PartiallyRefunded"] = 14] = "PartiallyRefunded";
})(OrderStatus || (OrderStatus = {}));
